module.exports = __webpack_public_path__ + "img/232.19f77680.jpg";